import { defineSlotRecipe } from '@chakra-ui/react';

// v2 parts track/thumb → v3 slots control/thumb. colorScheme functions became
// colorPalette tokens; mode(light, dark) collapsed to the light value.
//
// Geometry is driven by v3's own --switch-width/--switch-height vars, exactly
// as v2 drove it from --switch-track-width/--switch-track-height. Both versions
// size the thumb to the track height and slide it by (width - height). v2's
// track was also `box-sizing: content-box` (set by the v2 Switch component)
// with this theme's 2px padding outside those sizes, so md was 34×20 overall;
// the control below restores both. Do NOT also set an explicit thumb
// transform: v3's base already applies
// `translate: var(--switch-x)` when checked, and a hand-written translateX adds
// to it rather than replacing it, which throws the thumb outside the track.
const switchSlotRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'thumb'],
  base: {
    root: {
      colorPalette: 'blue',
    },
    control: {
      boxSizing: 'content-box',
      p: '2px',
      _focus: {
        boxShadow: '0 0 0 3px {colors.gray.100}',
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
      },
      _checked: {
        _focus: {
          boxShadow: '0 0 0 3px {colors.colorPalette.200}',
        },
      },
    },
    thumb: {
      bg: 'white',
    },
  },
  variants: {
    // v3's solid variant insets the thumb with `scale: 0.8`; v2's filled the
    // full track height. Reset here, since a `scale` in base would lose to the
    // variant. The same goes for the colours: solid sets the track to
    // bg.emphasized / colorPalette.solid (gray.200 / colorPalette.600) and
    // gives the thumb a shadow, so v2's gray.300 / colorPalette.500 track and
    // shadowless thumb are set here too, not in base.
    variant: {
      solid: {
        control: {
          bg: 'gray.300',
          _checked: {
            bg: 'colorPalette.500',
          },
        },
        thumb: {
          scale: '1',
          boxShadow: 'none',
          // v2's thumb stayed white when checked; v3's solid variant would swap it
          // to colorPalette.contrast.
          _checked: {
            bg: 'white',
          },
        },
      },
    },
    size: {
      sm: {
        root: {
          '--switch-width': '1.375rem',
          '--switch-height': '0.75rem',
        },
      },
      md: {
        root: {
          '--switch-width': '1.875rem',
          '--switch-height': '1rem',
        },
      },
      lg: {
        root: {
          '--switch-width': '2.875rem',
          '--switch-height': '1.5rem',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default switchSlotRecipe;
